<template>
  <div v-if="moduleCreator" class="card-wrapper h-100">

    <div
      v-if="isPreset || isUserComponent"
      class="template-actions position-absolute top-0 start-0 m-1"
      style="z-index: 10"
    >
      <button class="btn btn-light btn-sm" @click.stop="onRename">✎</button>
      <button class="btn btn-light btn-sm text-danger" @click.stop="onDelete">
        ✕
      </button>
    </div>

   
    <div
      class="card text-center pt-2 my-2 position-relative h-100 d-flex flex-column"
      style="width: 18rem; cursor: pointer"
      data-bs-toggle="modal"
      data-bs-target="#modulePropBoardModal"
      @click="onClickCard"
    >
      
      <span
        v-if="isPreset"
        class="badge bg-warning text-dark position-absolute top-0 end-0 m-2"
      >
        Preset
      </span>
      <span
        v-else-if="isUserComponent"
        class="badge bg-info text-dark position-absolute top-0 end-0 m-2"
      >
        User JSON
      </span>
      <span
        v-else
        class="badge bg-secondary position-absolute top-0 end-0 m-2"
      >
        Built-in
      </span>

     
<div class="w-auto mx-auto">
  
  <svg
    v-if="moduleCreator && moduleCreator.sample"
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="100"
    :fill="fillColor"
    :stroke="fillColor"
    :stroke-width="strokeWidth"
  >
    <component :is="moduleCreator.sample" />
  </svg>

 
  <svg
    v-else-if="hasPendingModule"
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="100"
    :viewBox="cardViewBox"
    :fill="fillColor"
    :stroke="fillColor"
    :stroke-width="strokeWidth"
  >
    <SvgModuleVue
  :id="moduleCreator.pendingModule.id"
  :topLeftCorner="moduleCreator.pendingModule.elementsToRender.topLeftCorner"
  :borderShapes="moduleCreator.pendingModule.elementsToRender.borderShapes"
  :maskShapes="moduleCreator.pendingModule.elementsToRender.maskShapes"
  :centerPoint="moduleCreator.pendingModule.elementsToRender.centerPoint"
  :hightlightOffset="0"
/>

  </svg>

  
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="150"
    height="100"
    :fill="fillColor"
    :stroke="fillColor"
    :stroke-width="strokeWidth"
  >
    <rect x="10" y="10" width="130" height="80" rx="8" ry="8" />
  </svg>
</div>


     
      <div class="card-body d-flex flex-column">
        <h5 class="card-title mb-1">{{ title }}</h5>

        
        <p v-if="isPreset && baseName" class="text-muted small mb-2">
          Based on: {{ baseName }}
        </p>
        <p v-else-if="isUserComponent" class="text-muted small mb-2">
          User component
        </p>
        <p v-else class="text-muted small mb-2">
          Built-in component
        </p>

        <p class="card-text small mb-3 flex-grow-1">
          {{ moduleCreator.description }}
        </p>

        <div class="mt-auto">
          <a href="#" class="btn btn-outline-success btn-sm" @click.prevent>
            Create
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useMoudleStore } from "@/stores/module";

import SvgModuleVue from "@/components/SvgModule.vue";

import SampleChamber from "@/assets/moduleSamples/SampleChamber.vue";
import SampleDelayChannel from "@/assets/moduleSamples/SampleDelayChannel.vue";
import SampleFilter from "@/assets/moduleSamples/SampleFilter.vue";
import SampleTeslaValve from "@/assets/moduleSamples/SampleTeslaValve.vue";
import SampleDroplet from "@/assets/moduleSamples/SampleDroplet.vue";
import SampleTransition from "@/assets/moduleSamples/SampleTransition.vue";

export default defineComponent({
  components: {
    SvgModuleVue,
    SampleChamber,
    SampleDelayChannel,
    SampleFilter,
    SampleTeslaValve,
    SampleDroplet,
    SampleTransition
  },
  props: {
    moduleCreator: { type: Object, required: true }
  },
  data() {
    return {
      fillColor: "dodgerblue",
      strokeWidth: 7
    };
  },
  computed: {
    title() {
      return (
        this.moduleCreator?.displayName ||
        this.moduleCreator?.moduleName ||
        "Component"
      );
    },
    
    isPreset() {
      return !!this.moduleCreator?.isUserTemplate;
    },
    
    isUserComponent() {
      return !!this.moduleCreator?.isUserComponent;
    },
    baseName() {
      return this.moduleCreator?.baseModuleName || "";
    },

    hasPendingModule() {
      const m = this.moduleCreator?.pendingModule;
      const e = m?.elementsToRender;
      return (
        !!m &&
        !!e &&
        Array.isArray(e.topLeftCorner) &&
        Array.isArray(e.centerPoint) &&
        Array.isArray(e.borderShapes) &&
        Array.isArray(e.maskShapes)
      );
    },

    
    cardViewBox() {
      if (!this.hasPendingModule) {
        return "0 0 150 100";
      }

      const m = this.moduleCreator.pendingModule;
      const tl = m.elementsToRender.topLeftCorner;
      const cp = m.elementsToRender.centerPoint;

      const x = tl[0] - 200;
      const y = tl[1] - 200;
      const w = (cp[0] - x) * 2 + 400;
      const h = (cp[1] - y) * 2 + 400;

      return `${x} ${y} ${w} ${h}`;
    }
  },
  methods: {
   
    onClickCard() {
      const store = useMoudleStore();
      const list = store.moduleFactory;
      const idx = list.indexOf(this.moduleCreator);
      if (idx >= 0) {
        store.selectModule(idx);
      } else {
        console.warn(
          "[ComponentBoardItem] creator not found in moduleFactory",
          this.moduleCreator
        );
      }
    },

    
    onRename() {
      const store = useMoudleStore();
      const current = this.title;
      const next = window.prompt(
        this.isPreset ? "New template name:" : "New component name:",
        current
      );
      if (!next || !next.trim()) return;
      const newName = next.trim();
      if (newName === current) return;

      
      if (this.isPreset) {
        if (!this.moduleCreator?.templateId) {
          console.error("Template has no templateId", this.moduleCreator);
          return;
        }
        if (typeof store.renameUserTemplate === "function") {
          store.renameUserTemplate(this.moduleCreator.templateId, newName);
        } else {
          console.warn(
            "[ComponentBoardItem] store.renameUserTemplate is not defined"
          );
        }
        return;
      }

      
      if (this.isUserComponent) {
        const oldName =
          this.moduleCreator.moduleName || this.moduleCreator.displayName;
        if (!oldName) {
          console.error(
            "UserComponent has no moduleName/displayName",
            this.moduleCreator
          );
          return;
        }
        if (typeof store.renameUserComponent === "function") {
          store.renameUserComponent(oldName, newName);
        } else {
          console.warn(
            "[ComponentBoardItem] store.renameUserComponent is not defined"
          );
        }
      }
    },

   
    onDelete() {
      const store = useMoudleStore();
      const name = this.title;
      if (!window.confirm(`Delete "${name}"?`)) return;

     
      if (this.isPreset) {
        if (!this.moduleCreator?.templateId) {
          console.error("Template has no templateId", this.moduleCreator);
          return;
        }
        if (typeof store.deleteUserTemplate === "function") {
          store.deleteUserTemplate(this.moduleCreator.templateId);
        } else {
          console.warn(
            "[ComponentBoardItem] store.deleteUserTemplate is not defined"
          );
        }
        return;
      }

      
      if (this.isUserComponent) {
        const compName =
          this.moduleCreator.moduleName || this.moduleCreator.displayName;
        if (!compName) {
          console.error(
            "UserComponent has no moduleName/displayName",
            this.moduleCreator
          );
          return;
        }
        if (typeof store.deleteUserComponent === "function") {
          store.deleteUserComponent(compName);
        } else {
          console.warn(
            "[ComponentBoardItem] store.deleteUserComponent is not defined"
          );
        }
      }
    }
  }
});
</script>

<style scoped>
.card-wrapper {
  position: relative;
}
.template-actions {
  pointer-events: auto;
}
</style>
